import httpClient from "./httpClient";

const base = "/subject-configurations";

export function listSubjectConfigurations(classId, groupId) {
  return httpClient.get(base, { params: { classId, groupId } }).then((res) => res.data.data);
}

export function createSubjectConfiguration(payload) {
  return httpClient.post(base, payload).then((res) => res.data.data);
}

export function updateSubjectConfigurationsBulk(payload) {
  return httpClient.post(`${base}/bulk-update`, payload).then((res) => res.data);
}

export function deleteSubjectConfiguration(id) {
  return httpClient.delete(`${base}/${id}`).then((res) => res.data);
}
